var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 57,
  height: 57,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.632 34.446-1.984 7.407-7.251.153A28.373 28.373 0 0 1 0 28.5a28.36 28.36 0 0 1 3.187-13.107h.001l6.456 1.184 2.829 6.417a16.942 16.942 0 0 0-.915 5.506c0 2.092.38 4.096 1.074 5.946Z",
  fill: "#FBBB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.502 23.176A28.53 28.53 0 0 1 57 28.5c0 2.04-.214 4.03-.623 5.95-1.387 6.534-5.012 12.238-10.034 16.275l-.002-.001-8.132-.415-1.15-7.185a16.985 16.985 0 0 0 7.308-8.674h-15.24V23.176h27.375Z",
  fill: "#518EF8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m46.34 50.724.002.001A28.38 28.38 0 0 1 28.5 57C17.646 57 8.21 50.934 3.396 42.006l9.236-7.56c2.407 6.423 8.604 10.996 15.868 10.996 3.122 0 6.048-.844 8.558-2.318l9.283 7.6Z",
  fill: "#28B446"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.691 6.561 37.46 14.12a16.846 16.846 0 0 0-8.96-2.562c-7.428 0-13.74 4.782-16.026 11.436l-9.285-7.6h-.001C7.93 6.247 17.485 0 28.5 0A28.38 28.38 0 0 1 46.69 6.561Z",
  fill: "#F14336"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h57v57H0z"
})))));
export { SvgGoogle as ReactComponent };
export default __webpack_public_path__ + "f01d6ff462b50e14049aab1354ec96d7.svg";